<script setup lang="ts">
// Small bidder-paddle illustration used in the RegisterPromptBanner.
// Paddle is drawn upright (head on top, handle below) and the whole
// group rotates -20° around its center so the rotation stays clean at
// any size.
</script>

<template>
  <svg
    class="paddle-illo"
    viewBox="0 0 80 72"
    role="img"
    aria-label="Bidder paddle"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="40"
      cy="38"
      r="28"
      fill="#FFF1E0"
    />

    <g
      stroke="#F2A93B"
      stroke-width="2.5"
      stroke-linecap="round"
    >
      <path d="M14 18 L10 14" />
      <path d="M20 12 L18 6" />
      <path d="M28 10 L29 4" />
    </g>

    <g transform="rotate(-20 40 38)">
      <rect
        x="37"
        y="40"
        width="6"
        height="22"
        rx="3"
        fill="#B36A1E"
      />
      <rect
        x="24"
        y="14"
        width="32"
        height="30"
        rx="6"
        fill="#F2A93B"
        stroke="#B36A1E"
        stroke-width="2"
      />
      <text
        x="40"
        y="34"
        fill="#FFFFFF"
        font-family="system-ui, -apple-system, sans-serif"
        font-size="14"
        font-weight="700"
        text-anchor="middle"
      >42</text>
    </g>

    <g
      stroke="#3DB6A6"
      stroke-width="2.5"
      stroke-linecap="round"
    >
      <path d="M62 18 L62 24" />
      <path d="M59 21 L65 21" />
    </g>
  </svg>
</template>

<style scoped>
.paddle-illo {
  display: block;
  width: 100%;
  height: 100%;
}
</style>
